// Date formatting utilities — all dates across the app use dd/MM/yyyy format.
import { format, parseISO, isValid } from "date-fns";
import { it as itLocale } from "date-fns/locale";

/** "2026-09-15" or Date → "15/09/2026". Returns "" on invalid input. */
export function formatDate(value) {
  if (!value) return "";
  const d = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(d)) return "";
  return format(d, "dd/MM/yyyy");
}

/** Alias of `formatDate` kept for callers that historically rendered a
 * shorter month-name variant. User request 15/09/2026: numeric only
 * everywhere → both helpers now return `dd/MM/yyyy` for consistency. */
export function formatDateShort(value) {
  if (!value) return "";
  const d = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(d)) return "";
  return format(d, "dd/MM/yyyy");
}

/** ISO datetime → "15/09/2026 14:32". */
export function formatDateTime(value) {
  if (!value) return "";
  const d = typeof value === "string" ? parseISO(value) : new Date(value);
  if (!isValid(d)) return "";
  return format(d, "dd/MM/yyyy HH:mm");
}
